
import { SelectedFiltersBase } from '../selected-filters-base';

import './style.scss';

interface IProps {
  isVacationRentals?: boolean | null | undefined;
  isCars?: boolean | null | undefined;

  onFiltersOrSortChange: (isSortChange?: boolean) => void;
}

export function SelectedFiltersHeader(props: IProps) {
  const { isVacationRentals, isCars, onFiltersOrSortChange } = props;

  return (
    <SelectedFiltersBase isVacationRentals={isVacationRentals} isCars={isCars} onFiltersOrSortChange={onFiltersOrSortChange} displayClearAllHeader />
  );
}
